// =====================================================================
// CLINIC ADMIN SERVICE — 22 endpoints do workflow "Agenda Admin CRUD v2"
// + 1 helper pra listar tenants acessiveis (esse ultimo vai pro backend
// CRM, nao pro n8n).
//
// Todas as chamadas exigem `slug` (params) — o interceptor do n8nApi
// usa isso pra injetar o Bearer token correto pra aquele tenant.
//
// Fase 3 white-label (S38). Consome os endpoints REST que estao em
// prod desde a S37 (n8n.clinicaclee.com/webhook/clinic-api/v2/admin/*).
// =====================================================================
import n8nApi from "./clinicAdminApi";
import api from "./api";

// ---------- CLINIC CONFIG (GET, PUT) ----------

export const getClinicConfig = async (slug) => {
  const { data } = await n8nApi.get("/v2/admin/config", { params: { slug } });
  return data;
};

export const updateClinicConfig = async (slug, payload) => {
  const { data } = await n8nApi.put("/v2/admin/config", payload, {
    params: { slug }
  });
  return data;
};

// ---------- PROFESSIONALS (CRUD) ----------

export const listProfessionals = async (slug) => {
  const { data } = await n8nApi.get("/v2/admin/professionals", {
    params: { slug }
  });
  return data;
};

export const createProfessional = async (slug, payload) => {
  const { data } = await n8nApi.post("/v2/admin/professionals", payload, {
    params: { slug }
  });
  return data;
};

export const updateProfessional = async (slug, id, payload) => {
  const { data } = await n8nApi.put("/v2/admin/professionals", payload, {
    params: { slug, id }
  });
  return data;
};

export const deleteProfessional = async (slug, id) => {
  const { data } = await n8nApi.delete("/v2/admin/professionals", {
    params: { slug, id }
  });
  return data;
};

// ---------- PROTOCOLS (CRUD) ----------

export const listProtocols = async (slug) => {
  const { data } = await n8nApi.get("/v2/admin/protocols", { params: { slug } });
  return data;
};

export const createProtocol = async (slug, payload) => {
  const { data } = await n8nApi.post("/v2/admin/protocols", payload, {
    params: { slug }
  });
  return data;
};

export const updateProtocol = async (slug, id, payload) => {
  const { data } = await n8nApi.put("/v2/admin/protocols", payload, {
    params: { slug, id }
  });
  return data;
};

export const deleteProtocol = async (slug, id) => {
  const { data } = await n8nApi.delete("/v2/admin/protocols", {
    params: { slug, id }
  });
  return data;
};

// ---------- SERVICES (CRUD) ----------

export const listServices = async (slug) => {
  const { data } = await n8nApi.get("/v2/admin/services", { params: { slug } });
  return data;
};

export const createService = async (slug, payload) => {
  const { data } = await n8nApi.post("/v2/admin/services", payload, {
    params: { slug }
  });
  return data;
};

export const updateService = async (slug, id, payload) => {
  const { data } = await n8nApi.put("/v2/admin/services", payload, {
    params: { slug, id }
  });
  return data;
};

export const deleteService = async (slug, id) => {
  const { data } = await n8nApi.delete("/v2/admin/services", {
    params: { slug, id }
  });
  return data;
};

// ---------- TEMPLATES (CRUD) ----------

export const listTemplates = async (slug) => {
  const { data } = await n8nApi.get("/v2/admin/templates", { params: { slug } });
  return data;
};

export const createTemplate = async (slug, payload) => {
  const { data } = await n8nApi.post("/v2/admin/templates", payload, {
    params: { slug }
  });
  return data;
};

export const updateTemplate = async (slug, id, payload) => {
  const { data } = await n8nApi.put("/v2/admin/templates", payload, {
    params: { slug, id }
  });
  return data;
};

export const deleteTemplate = async (slug, id) => {
  const { data } = await n8nApi.delete("/v2/admin/templates", {
    params: { slug, id }
  });
  return data;
};

// ---------- BENEFITS / CONVENIOS (CRUD) ----------

export const listBenefits = async (slug) => {
  const { data } = await n8nApi.get("/v2/admin/benefits", { params: { slug } });
  return data;
};

export const createBenefit = async (slug, payload) => {
  const { data } = await n8nApi.post("/v2/admin/benefits", payload, {
    params: { slug }
  });
  return data;
};

export const updateBenefit = async (slug, id, payload) => {
  const { data } = await n8nApi.put("/v2/admin/benefits", payload, {
    params: { slug, id }
  });
  return data;
};

export const deleteBenefit = async (slug, id) => {
  const { data } = await n8nApi.delete("/v2/admin/benefits", {
    params: { slug, id }
  });
  return data;
};

// ---------- UNITS / UNIDADES (CRUD) — agenda por data ----------

export const listUnits = async (slug) => {
  const { data } = await n8nApi.get("/v2/admin/units", { params: { slug } });
  return data;
};

export const createUnit = async (slug, payload) => {
  const { data } = await n8nApi.post("/v2/admin/units", payload, {
    params: { slug }
  });
  return data;
};

export const updateUnit = async (slug, id, payload) => {
  const { data } = await n8nApi.put("/v2/admin/units", payload, {
    params: { slug, id }
  });
  return data;
};

export const deleteUnit = async (slug, id) => {
  const { data } = await n8nApi.delete("/v2/admin/units", {
    params: { slug, id }
  });
  return data;
};

// ---------- AVAILABILITY / DISPONIBILIDADE POR DATA (CRUD) ----------

export const listAvailability = async (slug) => {
  const { data } = await n8nApi.get("/v2/admin/availability", { params: { slug } });
  return data;
};

export const createAvailability = async (slug, payload) => {
  const { data } = await n8nApi.post("/v2/admin/availability", payload, {
    params: { slug }
  });
  return data;
};

export const updateAvailability = async (slug, id, payload) => {
  const { data } = await n8nApi.put("/v2/admin/availability", payload, {
    params: { slug, id }
  });
  return data;
};

export const deleteAvailability = async (slug, id) => {
  const { data } = await n8nApi.delete("/v2/admin/availability", {
    params: { slug, id }
  });
  return data;
};

// ---------- TENANTS ACESSIVEIS (backend CRM, nao n8n) ----------
// Retorna lista de { id, slug, clinic_name, company_id, primary_color, logo_url }
// pra alimentar o dropdown de troca de slug no painel.
export const listAccessibleClinics = async () => {
  const { data } = await api.get("/clinic-admin/clinics");
  return data;
};

// ---------- UPLOAD DE LOGO (backend CRM, nao n8n) ----------
// Envia file multipart/form-data pro endpoint /clinic-admin/upload-logo.
// Backend valida (admin OR super + slug pertence ao tenant), salva em
// /app/public/brand/<slug>-<ts>.<ext> e retorna URL publica.
// Cliente pode usar a URL pra preencher logo_url no clinic_config (PUT separado).
export const uploadClinicLogo = async (slug, file, onProgress) => {
  if (!slug) throw new Error("slug requerido");
  if (!file) throw new Error("arquivo requerido");
  const form = new FormData();
  form.append("slug", slug);
  form.append("logo", file);
  const { data } = await api.post("/clinic-admin/upload-logo", form, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => {
      if (onProgress && e.total) {
        onProgress(Math.round((e.loaded / e.total) * 100));
      }
    }
  });
  return data;
};
